import './App.css';
import CloudIcon from '@mui/icons-material/Cloud';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import "moment/min/locales";

import { useEffect, useState } from 'react';
import SelectCity from './selectCity';
import { useSelector, useDispatch } from 'react-redux';
import { fetchApiWeather } from './features/weather/weatherSlice';

// api
//eg
// https://api.openweathermap.org/data/2.5/weather?lat=26.8206&lon=30.8025&appid=012ef46892a7d01fbeb3b810ef8f55ee
// rid
// https://api.openweathermap.org/data/2.5/weather?lat=24.774265&lon=46.738586&appid=012ef46892a7d01fbeb3b810ef8f55ee
// moroco
// https://api.openweathermap.org/data/2.5/weather?lat=	33.589886&lon=-7.603869&appid=012ef46892a7d01fbeb3b810ef8f55ee
// api
const theme = createTheme({
  typography: {
    fontFamily: ['IBM', 'sans-serif'].join(','),
    allVariants: {
      fontFamily: 'IBM, sans-serif',
    }
  }
});
function App() {
  // code redux
  const {isLoding, weatherData} = useSelector((state) => state.weather);
  const dispatchWeather = useDispatch();
  //api
  const [apiState, setApiState] = useState('https://api.openweathermap.org/data/2.5/weather?lat=26.8206&lon=30.8025&appid=012ef46892a7d01fbeb3b810ef8f55ee');
  function handleSetApi(value){
    setApiState(value);
  }
  // traslate
  const { t, i18n } = useTranslation();
  // data state
  const [date, setDate] = useState("");
  // lang state
  const [lang, setLang] = useState('ar');
  setTimeout(() => {
    setDate(moment().format('MMMM Do YYYY, h:mm:ss a'));
  }, 1000);
  // all data weather state
  // handle change languege
  function changeLanguege(){
    if (lang === 'ar') {
      setLang('en');
      i18n.changeLanguage('en');
      moment.locale('en');
    } else {
      setLang('ar');
      i18n.changeLanguage('ar');
      moment.locale('ar');
    }
  }

  useEffect(()=>{
    dispatchWeather(fetchApiWeather(apiState));
    i18n.changeLanguage(lang);
    moment.locale(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiState]);
  const direction = lang === 'ar' ? 'rtl' : 'ltr';
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Container maxWidth={"sm"}>
          {/* div to cunter */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}>
            {/* card */}
            <div dir={direction} style={{
              background:'rgb(28 52 91 / 36%)', 
              width: '100%',
              color: 'white',
              padding: '10px',
              borderRadius: '15px',
              position: 'relative',
              }} 
              className='parent'>

              <div className='content'>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                }} className='info'>
                    {/* info */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'end',
                        gap: '20px'
                      }}>
                      <h1>
                        {t(weatherData.city)}
                      </h1>
                      <h5>{date}</h5>
                    </div>
                    {/* info */}
                  {/* list to change city */}
                  <SelectCity api={apiState} setApi={handleSetApi}/>
                  {/* list to change city */}
                </div>
                <hr/>
                {/* content */}
                <div style={{display: 'flex', justifyContent: 'space-around'}}>
                  {/* degree */}
                  <div className='degree'>
                    {/* temp */}
                    <div style={{
                      display: 'flex',
                      alignContent: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                    }}>
                      <h1 style={{fontWeight: '400', fontSize: '45px'}}>
                        {weatherData.temp + "°C"}
                        {isLoding ? <CircularProgress style={{color: 'white'}}/> : ""}
                      </h1>
                      <img src={weatherData.icon} alt='type img'/>
                    </div>
                    {/* temp */}

                    {/* description */}
                    <h4 style={{fontWeight: '200'}}>{t(weatherData.description)}</h4>
                    {/* description */}

                    {/* min & max */}
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <h5>{t("Min")}: {weatherData.min}</h5>
                      <h5 style={{margin: '0 10px'}}>|</h5>
                      <h5>{t("Max")}: {weatherData.max}</h5>
                    </div>
                    {/* min & max */}
                  </div>
                  {/* degree */}

                  {/* ICON */}
                  <CloudIcon style={{fontSize: "200px"}}/>
                  {/* ICON */}
                </div>
                {/* content */}

              </div>
            </div>
            {/* card */}
            
            {/* div btn translate */}
            <div dir={direction} style={{width: '100%', display: 'flex', justifyContent: 'end', margin: '10px 0'}}>
              <Button style={{color: 'white', textTransform: 'capitalize'}} variant="text" onClick={changeLanguege}>{i18n.language === 'ar'? 'انجليزى' : "Arabic"}</Button>
            </div>
            {/* div btn translate */}
            
        </div>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default App;
